import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container } from 'reactstrap';

export function DisclaimerInfo({ isBasics = false }) {
  return (
    <Container className="px-md-0">
      <hr className={classNames(isBasics ? 'mt-3 mb-1_5' : 'my-1_5')} />

      <h3 className="size-14 m-0">How Pre-Qualification Works with Edmunds Participating Lenders</h3>
      <p className="mb-1 size-14">
        Obtain pre-qualification for auto financing with an Edmunds Participating Lender (listed below) prior to
        visiting a participating dealer. Participating Lenders may review the information you provide to determine
        whether you pre-qualify with no impact to your credit score. If you pre-qualify with one or more of our
        Participating Lenders, you will be able to see your monthly payments, APRs and offer summaries for eligible
        vehicles you may be considering. Eligible vehicles are those vehicles that meet the criteria for
        prequalification and are offered for sale by dealers that partner with our Participating Lenders. Your request
        for pre-qualification may not be submitted to all Participating Lenders.
      </p>
      <p className="mb-1 size-14">
        Remember, your pre-qualification can only be used for the purchase of one, personal use vehicle. The offer
        summary will include an estimate of the financing terms (including down payment) you could qualify for when you
        apply for financing at the dealer. When you are ready to finance a vehicle, you can send your offer summary to a
        participating dealer to let them know you are conditionally pre-qualified for auto financing with a Edmunds
        Participating Lender. If you have recently applied and funded another loan with an Edmunds Participating Lender,
        this might impact your eligibility for a new loan with this pre-qualification.
      </p>
      <>
        <h3 className="size-14 m-0">Edmunds Participating Lenders</h3>
        <ul className="ps-1_5">
          <li className="size-14"> Capital One, www.capitalone.com/cars</li>
        </ul>
      </>
    </Container>
  );
}

DisclaimerInfo.propTypes = {
  isBasics: PropTypes.bool,
};
